// Angular imports
import { Injectable } from '@angular/core';

// RxJS imports
import { Observable, forkJoin } from 'rxjs';

// Model imports
import { AttachmentParameterDto } from '../../_models/attachment-parameter-dto';

@Injectable({
  providedIn: 'root'
})
export class FileReaderService {
  constructor() {}

  readFile(
    file: File,
    attachmentFieldId?: number
  ): Observable<AttachmentParameterDto> {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    return new Observable((observer) => {
      // if success
      fileReader.onload = (ev) => {
        const uploadFileInfo = new AttachmentParameterDto();
        uploadFileInfo.fileName = file.name;
        uploadFileInfo.attachmentBase64 = (ev.target as any).result as string; // base 64 string
        uploadFileInfo['fieldId'] = attachmentFieldId;
        observer.next(uploadFileInfo);
        observer.complete();
      };

      // if failed
      fileReader.onerror = (error) => {
        observer.error(error);
      };
    });
  }

  readFiles(
    files: File[],
    attachmentFieldId?: number
  ): Observable<AttachmentParameterDto[]> {
    return forkJoin([
      ...files.map((file) => this.readFile(file, attachmentFieldId))
    ]);
  }
}
